;(function($, window, document){
    window.ResizerView = Me.view.extend({
        options: {

        },

        initialize: function() {
            _.bindAll(this, 'breakpointHandler');

            this.addEvents();
        },
        addEvents: function() {
            Me.dispatch.subscribe('breakpointChanged', this.breakpointHandler);
        },
        breakpointHandler: function(e, params){
            if(params.breakpoint == '767-'){
                $('section.full-height').css('min-height', '');
            }else{
                $('section.full-height').css('min-height', $(window).height());
            }
        }

    });
}(jQuery, window, document));
